import c from '../common';

export default{

    //


    //Title and Tabs
    "DataCenterTitle": "Data Center",
    //"TradeRecord":"Trade Record",
    "Voucher": c.voucher.en.uppercase,
    "Discount": c.discount.en.uppercase,

    "Sales": "Sales",
    "Issue": "Issue",
    "Transfer": "Transfer",
    "Redeem": "Redeem",
    "Discount":"Discount",


    "Bookings": "Bookings",

    "overview": "Overview",
    "AllRecord": "All Record",

    "Estamp": c.estamp.en,
    "Earning": "Earning",
    "Transfer": "Transfer",
    "Redeem": "Redeem",
    "Consumer": c.consumer.en.uppercase,
    "Amount": "Amount",
    "Point": "Point",
    "Transferor": "Transferor",
    "Receiver": "Receiver",
    "RedeemAmount": "Amount",
    "PointDeducted": "Point",
    "RedeemProduct": "Redeemed Product"
};